import { render, staticRenderFns } from "./surumGuncelle.vue?vue&type=template&id=ef5747b0"
import script from "./surumGuncelle.vue?vue&type=script&lang=js"
export * from "./surumGuncelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports